import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

type Props = React.PropsWithChildren;

export type CoachSuggestionContentComponent = React.ReactElement<Props>;

const CoachSuggestionContent = ({ children }: Props) => {
  return (
    <Typography2 variant="bodySecondary" component="div">
      {children}
    </Typography2>
  );
};

export default CoachSuggestionContent;
